export const UPDATE_SELECTED_SURVEY_TYPE = 'UPDATE_SELECTED_SURVEY_TYPE';

export const updateSelectedSurveyType = applicableToValue => ({
  type: UPDATE_SELECTED_SURVEY_TYPE,
  payload: applicableToValue,
});

const surveyTypeMap = {
  LABOR_BC_SUBSTANTIATION: 'LaborBCSubstantiation',
  LABOR_PROJECT_SUBSTANTIATION: 'LaborProjectSubstantiation',
};

const selectedSurveyTypeReducer = (state = 'LaborBCSubstantiation', action) => {
  switch (action.type) {
    case UPDATE_SELECTED_SURVEY_TYPE:
      return surveyTypeMap[action.payload] || 'LaborBCSubstantiation';
    default:
      return state;
  }
};

export default selectedSurveyTypeReducer;
